export const opiniao = [
  {
    img: require('../../images/opiniao_comprador_2.png'),
    title: 'Ficou muito melhor para dirigir',
    text: ''
  },
  {
    img: require('../../images/opiniao_comprador_3.png'),
    title: 'Melhorou a minha disposição',
    text: ''
  },
  {
    img: require('../../images/opiniao_comprador_5.png'),
    title: 'Estou me sentindo melhor no dia a dia',
    text: ''
  },
  {
    img: require('../../images/opiniao_comprador_6.png'),
    title: 'Mais leve e com mais energia',
    text: ''
  },
  {
    img: require('../../images/opiniao_comprador_7.png'),
    title: 'Maravilhoso!!',
    text: ''
  },
  {
    img: require('../../images/opiniao_comprador_8.png'),
    title: 'Não pretendo parar de tomar',
    text: ''
  },
  {
    img: require('../../images/opiniao_comprador_9.png'),
    title: 'Melhorou meus sintomas',
    text: ''
  },
  {
    img: require('../../images/opiniao_comprador_10.png'),
    title: 'Me sinto mais disposto',
    text: ''
  },
  {
    img: require('../../images/opiniao_comprador_11.png'),
    title: 'Até pra namorar melhorou',
    text: ''
  }
]

export const productFeatures = [
  {
    img: require('../../images/figado-icon.png'),
    title: 'Auxilia no metabolismo de gorduras no fígado.',
    text: ''
  },
  {
    img: require('../../images/anti-inflamatorio-icon.png'),
    title: 'Auxilia na resposta inflamatória do organismo',
    text: ''
  },
  {
    img: require('../../images/health-icon.png'),
    title: 'Apoia o bem-estar do fígado e vesícula biliar',
    text: ''
  },
  {
    img: require('../../images/anti-oxidant-icon.png'),
    title: 'Ativos com ação antioxidante que auxiliam no bem-estar digestivo',
    text: ''
  },
  {
    img: require('../../images/diuretic-icon.png'),
    title: 'Auxilia como diurético',
    text: ''
  }
]

export const ingredientes = [
  {
    img: require('../../images/cardo_mariano.jpg'),
    title: 'Cardo Mariano',
    text: 'Auxilia na proteção do fígado contra toxinas.'
  },
  {
    img: require('../../images/alcachofra.png'),
    title: 'Alcachofra',
    text: 'Favorece a produção da bile, melhorando a digestão de gorduras.'
  },
  {
    img: require('../../images/boldo.png'),
    title: 'Boldo',
    text: 'Auxilia nas funções naturais de eliminação de substâncias do organismo, aliviando desconfortos digestivos, como gases e má digestão.'
  },
  {
    img: require('../../images/curcuma.png'),
    title: 'Cúrcuma',
    text: 'Contribui para o equilíbrio dos processos inflamatórios.'
  },
  {
    img: require('../../images/laranja_moro.jpeg'),
    title: 'Laranja Moro',
    text: 'Auxilia no metabolismo de gorduras, contribuindo para o bem-estar hepático.'
  }
]

export const homeObjOne = {
    primary: true,
    lightBg: false,
    lightTopLine: true,
    lightText: true,
    lightTextDesc: true,
    topLine: '60 cápsulas por pote',
    headline: 'Nova fórmula mais potente que auxilia no funcionamento saudável do seu fígado',
    description:
      'PRÓ-FÍGADO agora reúne o melhor em uma única fórmula com ingredientes NATURAIS. Seu caminho para um melhor bem-estar hepático começa agora.',
    buttonLabel: 'EU QUERO',
    imgStart: 'start',
    img: require('../../images/capsula.png'),
    alt: 'Pote de PRÓ-FÍGADO com cápsulas',
    start: ''
  };
  
  export const homeObjTwo = {
    primary: true,
    lightBg: false,
    lightTopLine: true,
    lightText: true,
    lightTextDesc: true,
    topLine: '',
    headline: 'Acreditamos tanto no nosso produto que você terá a SUPER GARANTIA de 7 dias!',
    description:
      "Risco Zero Para Você! Para provar, devolvemos o seu dinheiro se o produto não atender as expectativas. Você terá até 7 dias após a compra para solicitar a devolução do seu dinheiro, simples assim!",
    buttonLabel: 'EU QUERO!',
    imgStart: 'start',
    img: require('../../images/show_2.png'),
    alt: 'PRÓ-FÍGADO',
    start: ''
  };
  
  export const homeObjThree = {
    primary: false,
    lightBg: true,
    lightTopLine: false,
    lightText: false,
    lightTextDesc: false,
    topLine: '',
    headline:
      'Como o PRÓ-FÍGADO funciona?',
    description:
      "O PRÓ-FÍGADO foi desenvolvido para complementar uma rotina de cuidados diários, oferecendo ao organismo ativos que auxiliam no equilíbrio fisiológico do fígado, podendo contribuir para a manutenção das funções hepáticas, inflamações leves e desconfortos digestivos associados à função hepática.",
    buttonLabel: 'EU QUERO',
    imgStart: '',
    img: require('../../images/show_1.png'),
    alt: 'PRÓ-FÍGADO',
    start: 'true'
  };
  
  export const homeObjFour = {
    primary: true,
    lightBg: false,
    lightTopLine: true,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Privacidade',
    headline: 'Todos os seus dados são armazenados em nosso servidor seguro',
    description:
      'Você nunca precisará se preocupar com o vazamento de suas informações. Nossa equipe de especialistas em segurança garantirá que seus registros sejam mantidos em segurança.',
    buttonLabel: 'EU QUERO',
    imgStart: 'start',
    img: require('../../images/propaganda7.png'),
    alt: 'PRÓ-FÍGADO',
    start: 'true'
  };